export const actionTypes = {
  ON_COUNTRY_POST_LOADING: "on-country-post-loading",
  ON_COUNTRY_POST_SUCCESS: "on-country-post-success",
  ON_COUNTRY_DATA_LOADING: "on-country-data-loading",
  ON_COUNTRY_DATA_DELETE_LOADING: "on-country-data-delete-loading",
  ON_COUNTRY_DATA_DELETE_SUCCESS: "on-country-data-delete-success",
  ON_COUNTRY_DATA_ERROR: "on-country-data-error",
  ON_COUNTRY_DATA_SUCCESS: "on-country-data-success",
  ON_COUNTRY_DATA: "on-country-data",
  ON_COUNTRY_DATA_QUERY: "on-country-data-query",
};
export const initialState = {
  countries: [],
  countryDataLoading: false,
  countryDataError: null,
  postCountryLoading: false,
  deleteCountryLoading: false,
  count: 0,
  total: 0,
};
